import {
  Backdrop,
  Button,
  Container,
  Fade,
  Grid,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Constants from "../App/Variables/Constants";
import init from "../helpers/WindowToken";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Form } from "reactstrap";
import "suneditor/dist/css/suneditor.min.css";
let fd = new FormData();

export default class Add_Testimonial extends Component {
  state = {
    name: "",
    description: "",
    loading: false,
    notification: false,
    image: "",
  };

  // addHowToPlay = (e) => {
  //   e.preventDefault();
  //   this.setState({
  //     loading: true,
  //   });
  //   fd.append("name", this.state.name);
  //   fd.append("image", this.state.image);
    
  //   if (init() === "success") {
  //     axios.post(Constants.postUrls.createTestimonial, fd).then((resp) => {
  //       console.log(resp);
  //       this.setState({
  //         loading: false,
  //         notification: true,
  //         message: resp.data.message,
  //       });
  //       setTimeout(() => {
  //         this.setState({
  //           notification: false,
  //           redirect: true,
  //         });
  //       }, 3000);
  //     });
  //   }
  // };
  addHowToPlay = (e) => {
    e.preventDefault();

    this.setState({ loading: true });

    let fd = new FormData();

    fd.append("name", this.state.name); // ✅ fixed
    fd.append("image", this.state.image);

    if (init() === "success") {
      axios.post(Constants.postUrls.createTestimonial, fd)
        .then((resp) => {
          this.setState({
            loading: false,
            notification: true,
            message: resp.data.message,
          });

          setTimeout(() => {
            this.setState({
              notification: false,
              redirect: true,
            });
          }, 3000);
        })
        .catch((err) => {
          console.log(err.response); // 🔥 debug
          this.setState({ loading: false });
        });
    }
  };
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleFile = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChange(content) {
    // console.log(content); //Get Content Inside Editor
    this.setState(
      {
        description: content,
      },
      () => {
        console.log(this.state.description);
      }
    );
  }
  render() {
    if (this.state.redirect) {
      return <Redirect to="/testimonial" />;
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h6">{this.props.title}</Typography>
            </Grid>
          </Grid>
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h5">Add Testimonial</Typography>
            </Grid>
          </Grid>
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={true}
              color={"green"}
              autoHideDuration={6000}
              message={"Created Successfully"}
            ></Snackbar>
          ) : null}
          <div
            style={{
              background: "#5b5757",
              padding: "20px",
              borderRadius: "10px",
              // color: rgba(0, 0, 0, 0.87);
              width: "100%",
              border: "0",
              display: "flex",
              position: "relative",
              fontSize: ".875rem",
              minWidth: "0",
              wordWrap: " break-word",
              /* background: #FFF; */
              boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
              marginTop: "30px",
              borderRadius: "6px",
              marginBottom: "30px",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>
            {/* <span
              style={{
                color: "White",
                marginTop: "-55px",
                marginLeft: "78px",
                marginBottom: "35px",
                fontSize: "17px",
              }}
            >
              Add How To Play
            </span> */}
            <Grid item sm={12} style={{ textAlign: "left", marginTop: "30px" }}>
              <Form onSubmit={this.addHowToPlay}>
                <TextField
                  type="text"
                  id="outlined-basic"
                  onChange={this.handleInput}
                  label="Title"
                  name="name"
                  variant="outlined"
                  required={true}
                  style={{
                    marginRight: "20px",
                    width: "30%",
                    marginBottom: "20px",
                  }}
                />
                <div>
                  <label>Upload Image</label>
                  <br />
                  <input
                    id="image"
                    name="image"
                    onChange={this.handleFile}
                    accept="image/*"
                    type="file"
                    required={true}
                    style={{ marginTop: "15px" }}
                  />
                </div>
                {/* <br />
                <TextField
                  id="outlined-basic"
                  label="Description"
                  onChange={this.handleInput}
                  name="description"
                  variant="outlined"
                  style={{ marginRight: "20px", width: "50%" }}
                /> */}

                <br />
                <Button
                  variant="contained"
                  type="submit"
                  Size={15}
                  color="primary"
                  style={{ marginRight: "20px", marginTop: "35px" }}
                >
                  {this.state.loading ? "Adding.." : "Add"}
                </Button>

                <Link
                  to={{
                    pathname: "/testimonial",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    Size={15}
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link>
              </Form>
            </Grid>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={this.state.open}
            onClose={this.handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Fade in={this.state.open}>
              <div
                style={{
                  background: "#fff",
                  width: "50%",
                  padding: "32px",
                }}
              >
                <h2 id="transition-modal-title">Transition modal</h2>
                <p id="transition-modal-description">
                  react-transition-group animates me.
                </p>
              </div>
            </Fade>
          </Modal>
        </Container>
      );
    }
  }
}
